<div class="container">
  <div class="title-wrap">
    <h1 class="title">{{ 'pages.apps.title' | translate }}</h1>
  </div>
  <ng-container *ngIf="allApps$ | async as allApps; else loading">
    <div class="content-wrap">
        <div class="empty" *ngIf="allApps?.length === 0 else content">
          <span>{{ 'pages.apps.empty' | translate }}</span>
        </div>

      <ng-template #content>
        <div class="app-list">
          <app-app-view *ngFor="let app of allApps"
                        class="app-item"
                        [app]="app"
                        [restaurants]="(allRestaurants$ | async) ?? []"
                        [routerLink]="['/chains', currentChain.id, 'apps', 'app', app.id]"
          >
          </app-app-view>
        </div>
      </ng-template>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>

</div>
